import {createContext, useContext} from 'react'
import type {RosFeatureContextValue} from './types'

export const RosFeatureContext = createContext<RosFeatureContextValue | null>(null)

export function useRosFeatures(): RosFeatureContextValue {
  const value = useContext(RosFeatureContext)
  if (!value) throw new Error('useRosFeatures must be used within RosFeatureProvider')
  return value
}
